const HOUR_SCHEDULE_FROM = 8;
const HOUR_SCHEDULE_TO = 21;

export const createArrayOfTime = (minutesInterval: number = 15) => {
  let arr = [];

  for (let hours = HOUR_SCHEDULE_FROM; hours < HOUR_SCHEDULE_TO; hours++) {
    for (let minutes = 0; minutes < 60; minutes = minutes + minutesInterval) {
      let hh = '';
      let mm = '';

      hh = hours.toString().padStart(2, '0');
      mm = minutes.toString().padStart(2, '0');

      arr.push(`${hh}:${mm}`);
    }
  }

  return arr;
};
